const timestamp = () => new Date().toISOString();

export default timestamp;
